// Feature flags for MoneyHub. Set TEST_LAUNCH_MODE = false to re-enable
// the marketplace, invoicing, ledger, and payout surfaces.
export const TEST_LAUNCH_MODE = false;

export const SUPPORT_EMAIL = "moneyhubvip@outlook.com";

// Live countdown target for the payments-mode unlock. Update this to
// slide the timer. Format: "YYYY-MM-DDTHH:MM:SSZ" (UTC).
// Default: 60 days from Aug 16 2026 = mid-Oct 2026.
export const PAYMENTS_UNLOCK_DATE = "2026-10-15T12:00:00Z";
